<template>
    <div class="quesBankform">
        <div class="page-header">
            <el-page-header @back="goBack" :content="`${bId ? $t('QuesLibrary.EditQuestionBank'): $t('QuesLibrary.AddQuestionBank')} - ${$t('QuesLibrary.QuestionBankInfo')}`">
            </el-page-header>
        </div>
        <div class="form-box">
            <p class="title">{{bId ? $t('QuesLibrary.Edit'): $t('QuesLibrary.NewlyAdded')}}{{$t('QuesLibrary.QuestionBankInfo')}}</p>
            <el-form :model="ruleForm" :rules="rules" labelPosition="top" ref="ruleForm"  class="demo-ruleForm">
                <el-form-item :label="$t('QuesLibrary.QuestionBankName')" prop="name">
                    <el-input
                        size="medium"
                        maxlength="15"
                        show-word-limit  
                        v-model="ruleForm.name">
                    </el-input>
                </el-form-item>
                <el-form-item :label="$t('QuesLibrary.QuestionBankNumber')" prop="quesNo">
                    <el-input 
                        size="medium"
                        maxlength="20"
                        show-word-limit 
                        v-model="ruleForm.quesNo" 
                        :placeholder="$t('QuesLibrary.QuestionBankNumberLimit')">
                    </el-input>
                </el-form-item>
                <el-form-item :label="$t('QuesLibrary.QuestionBankCategory')" prop="type">
                    <el-select
                        size="medium"
                        v-model="ruleForm.type"
                        maxlength="10"
                        show-word-limit 
                        filterable
                        allow-create
                        default-first-option
                        :placeholder="$t('QuesLibrary.EnterOrSelectArticleLabel')"
                    >
                        <el-option
                            v-for="(item, index) in bankTypeList"
                            :key="index"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('QuesLibrary.Notes')" prop="remarks">
                    <el-input 
                        size="medium"
                        type="textarea"
                        maxlength="100"
                        show-word-limit  
                        rows="3"
                        v-model="ruleForm.remarks"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="medium" :loading="submitLoading" type="primary" @click="submitForm('ruleForm')">{{$t('QuesLibrary.Save')}}</el-button>
                    <el-button size="medium" :disabled="submitLoading" @click="resetForm('ruleForm')">{{$t('QuesLibrary.Resetting')}}</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import Paper from "@/components/examQuesTemplate/js/Paper.js"
import PaperWJ from "@/page/myQuestionnaire/js/Paper.js"
export default {
    name: 'QuesBankform',
    components: {
    },
    props: ['bId', 'isSystem','bankType'],
    data() {
        // 编号验证
        let checkNumber = (rule, value, callback) => {
            if (!value) {
				callback();
                // return callback(new Error('请输入题库编号'));
            }
            if (!/^\w+$/.test(value)) {
                callback(new Error(this.$t('QuesLibrary.CharacterMismatch')));
            } else {
                if (value.toString().length > 32 || value.toString().length < 1) {
                    callback(new Error(this.$t('QuesLibrary.LengthMismatch')));
                } else {
                    callback();
                }
            }
        };
        return {
            ruleForm: {
                name: '',
                quesNo: '',
                type: '',
                creater: '',
                remarks: '',
            },
            rules: {
                name: [
                    { required: true, message: this.$t('QuesLibrary.EnterTheNameOfTheQuestionBank'), trigger: 'blur' },
                ],
                quesNo: [
                    {required: false, validator: checkNumber, trigger: 'blur' },
                ],
                type: [
                    { required: false, message: this.$t('QuesLibrary.EnterQuestionBankCategory'), trigger: 'blur' }
                ],
                // creater: [
                //     { required: false, message: '请输入题库创建人', trigger: 'blur' }
                // ],
                remarks: [
                    { required: false, message: this.$t('QuesLibrary.EnterQuestionBankNotes'), trigger: 'blur' }
                ],
            },
            bankTypeList: [],
            paper: {},
            submitLoading: false
        }
    },
    computed:{
        userInfo() {
            return JSON.parse(window.localStorage.getItem('userInfo'))
        },
    },
    created() {
        this.ruleForm.createId = this.userInfo.id
        this.getbankType()
        if (this.bId) {
            this.getBankInfo()
        }
    },
    methods:{
        getBankInfo(){
            // 题库详情api
            let that = this
            let params = {
                    that: this,
                    url: `${this.$config.service.examBankDetail}?id=${this.bId}`,
                    method: "GET",
                    cb(res) {
                        console.log(res)
                        if (res.code == '0'){
                            that.ruleForm = {
                                name: res.resultBody.name,
                                quesNo: res.resultBody.quesNo,
                                type: res.resultBody.type,
                                creater: res.resultBody.createId,
                                remarks: res.resultBody.remark,
                            }
                        }
                    },
                };
                this.$util.request(params);
        },
        getbankType(){
            let that = this
            let data = this.$qs.stringify({
                'isSystem': this.isSystem, // 0自建题库 1系统题库
                'bankType': this.bankType
            })
            let params = {
                that: this,
                url: `${this.$config.service.examBankBankType}?${data}`,
                method: "GET",
                cb(res) {
                    console.log(res)
                    if (res.code == 0) {
                        that.bankTypeList = res.resultBody
                    }
                },
            };
            this.$util.request(params);
        },
        goBack() {
			if(this.$route.query.back){
				this.$router.push(
				    {
				        path: '/managementIndex',
				        query: {
				            back:this.$route.query.back
				        }
				    }
				)
			}else{
            this.$router.go(-1)
			}
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.submitLoading = true
                let data = {
                    name: this.ruleForm.name,
                    quesNo: this.ruleForm.quesNo, // 题库编号
                    type: this.ruleForm.type,
                    createId: this.ruleForm.createId, // 创建人
                    remark: this.ruleForm.remarks,
                    isSystemBank: this.isSystem, // 是否系统题库
                    id: this.bId
                }
                if (this.bId) {
                    this.UpdateBank(data)
                } else {
                    this.SaveBank(data)
                    this.paper = this.bankType == 0 ? new Paper(): new PaperWJ()
                }
                console.log(data)
                
            } else {
                console.log('error submit!!');
                return false;
            }
            });
        },
        SaveBank(obj) {
            let data = {...obj, bankType: this.bankType}
            let that = this
            let params = {
                that: this,
                url: `${this.$config.service.examBankSave}`,
                method: "POST",
                data: data,
                cb(res) {
                    console.log(res)
                    if (res.code == '0'){
                        that.setPaperJson(res.message)
                    } else {
                        that.$message.error(res.message)
                    }
                },
            };
            this.$util.request(params);
        },
        setPaperJson(id) {
            let that = this;
            let data = {
                id: id,
                paperjson: JSON.stringify(this.paper),
                bankType: this.bankType
            }
            let params = {
                that: this,
                url: `${this.$config.service.examBankAddQuess}`,
                method: "post",
                data: data,
                cb(res) {
                    if (res.code == '0') {
                        that.getbankType()
                        that.resetForm('ruleForm')
                        that.$message({
                            message: that.$t('main.AddedSuccessfully'),
                            type: 'success'
                        });
                        that.goBack()
                    } else {
                        that.$message.error(res.message)
                    }
                },
            };
            this.$util.request(params);
        },
        UpdateBank(data) {
            let that = this
            let params = {
                that: this,
                url: `${this.$config.service.examBankUpdate}`,
                method: "POST",
                data: data,
                cb(res) {
                    console.log(res)
                    if (res.code == '0'){
                        that.getbankType()
                        that.resetForm('ruleForm')
                        that.$message({
                            message: res.message,
                            type: 'success'
                        });
                        that.goBack()
                    } else {
                        that.$message.error(res.message)
                    }
                },
            };
            this.$util.request(params);
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    }
}
</script>

<style lang="scss" scoped>
.quesBankform{
    .page-header{
        padding: 20px
    }
    .form-box{ 
        width: 600px;
        margin: 40px auto 0 auto;
        .title{
            font-size: 16px;
            margin: 0 0 40px 30px;
        }
    }
}
.el-icon-loading{
    font-size:  14px;
}
</style>
